import $ from "jquery";

const sideNavToggle = $(".nav-title > .dropdown-toggle"),
  nestedNavToggle = $(".nav-title .menu-item .caret"),
  dropdownToggleAll = $(".side-menu .dropdown-toggle"),
  menuItem = $(".side-menu .menu-item"),
  dropdownMenu = $(".side-menu .dropdown-menu.inner .dropdown-menu");

function checkCurrent() {
  const currentParent = $(
    ".nav-title .current-menu-item.menu-item-has-children, .nav-title .current-menu-parent"
  );
  if (currentParent.length) {
    currentParent.find(".caret").addClass("opened");
    currentParent.children(".dropdown-menu").addClass("test").slideDown();
  }
}

function toggleSideNav() {
  sideNavToggle.on("click", function (e) {
    e.preventDefault();
    $(this).next(".dropdown-menu").slideToggle();
  });
}

function openNav() {
  nestedNavToggle.on("click", function (e) {
    e.preventDefault();
    const dropdownToggle = $(this).closest(".dropdown-toggle");
    dropdownToggleAll.removeClass("opened");
    nestedNavToggle.removeClass("opened");

    if (!dropdownToggle.siblings(".dropdown-menu").is(":visible")) {
      menuItem.removeClass("current-menu-ancestor");
      dropdownMenu.slideUp();
      $(this).addClass("opened");
      dropdownToggle.addClass("opened");
      dropdownToggle.closest(".menu-item").addClass("current-menu-ancestor");
      dropdownToggle.next(".dropdown-menu").slideDown();
    } else {
      $(this).removeClass("opened");
      dropdownToggle.removeClass("opened");
      dropdownToggle.closest(".menu-item").removeClass("current-menu-ancestor");
      dropdownToggle.next(".dropdown-menu").slideUp();
    }
  });
}

openNav();
toggleSideNav();
checkCurrent();
